import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { MAX_TOAST_TIME, MIN_TOAST_TIME } from "./constants.js";
import { ToastContent } from "./ui/ToastContent.js";
const Toast = ({ duration = 4, open, onClose, type, title, subtitle, textLink })=>{
    useEffect(()=>{
        if (!open) return;
        let showTime = duration;
        if (duration < MIN_TOAST_TIME) showTime = MIN_TOAST_TIME;
        if (duration > MAX_TOAST_TIME) showTime = MAX_TOAST_TIME;
        const timeout = setTimeout(()=>{
            if (open) onClose();
        }, 1000 * showTime);
        return ()=>clearTimeout(timeout);
    }, [
        open,
        duration
    ]);
    return open ? /*#__PURE__*/ jsx("div", {
        className: "tw-fixed tw-flex tw-w-full tw-justify-center sm:tw-w-auto tw-top-2.4 sm:tw-top-4 sm:tw-right-4 tw-z-popover",
        children: /*#__PURE__*/ jsx(ToastContent, {
            title: title,
            subtitle: subtitle,
            textLink: textLink,
            type: type,
            onClose: onClose
        })
    }) : null;
};
const Toast_Toast = Toast;
export default Toast_Toast;
export { Toast };
